/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, Fragment, useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { KTSVG } from '../../../../_metronic/helpers'
import { EnableSidebar } from '../../../../_metronic/layout/core'
import { verfyEmail } from '../../auth/core/_requests'

function getError(){
    return <div className="alert alert-warning d-flex align-items-center p-5 mb-10 w-100">
    <span className="bi bi-exclamation-triangle fs-3x me-3"></span>
    
    <div className="d-flex flex-column">
      <h5 className="mb-1">เกิดข้อผิดพลาด</h5>
      <span className='text-gray-800'>รหัสในการตรวจสอบบัญชีผู้ใช้งานไม่ถูกต้อง ไม่สามารถกำหนดค่าเริ่มต้นในการใช้งานได้</span>
    </div>
  </div>
}

function getVerifiedText(){
    return <div className="alert alert-success d-flex align-items-center p-5 mb-10 w-100">
    <span className="bi bi-shield-fill-check fs-3x me-3"></span>
    
    <div className="d-flex flex-column">
      <h5 className="mb-1">เปิดใช้งานบัญชีเรียบร้อย</h5>
      <span className='text-gray-800'>บัญชีของคุณพร้อมใช้งานแล้ว กรุณา login เพื่อเริ่มต้นใช้งานระบบ</span>
    </div>
  </div>
}

const EmailConfirmation: React.FC = () => {
    const [textFormatting, setTextFormatting] = useState<boolean>(false)
    const [searchParams, setSearchParams] = useSearchParams();
    let encoded_user_id = searchParams.get("confirm")
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState('');

    useEffect(() => {
        // React advises to declare the async function directly inside useEffect
        async function updateStatus() {
            try {
                await verfyEmail(encoded_user_id)
                setStatus('success')
                setLoading(false)
            } catch (error) {
                console.error(error)
                setStatus('error')
                setLoading(false)
            }
        };

        if (loading) {
            updateStatus()
        }
    }, [loading]);

    return (
        <>
            <div className='mb-0'>
                <div className='d-flex flex-stack flex-wrap'>
                    <div className='d-flex align-items-center py-1'>
                        <h1 className='fs-2x fw-bolder text-gray-900 mb-0 me-1'>
                            ตรวจสอบการเริ่มต้นใช้งานระบบ
                        </h1>
                    </div>
                </div>


                <div className='d-flex flex-stack flex-wrap mt-2'>
                    <div className='d-flex align-items-center py-1 w-100'>
                        {loading && <h3>
                            <span className="spinner-border spinner-border-sm align-middle me-2"></span>
                            กำลังตรวจสอบ...
                        </h3>}

                        {!loading && status == "error" && getError()}
                        {!loading && status == "success" && getVerifiedText()}
                    </div>

                </div>
            </div>

            <div className='separator separator-dashed border-gray-300 mt-8 mb-10'></div>

        </>
    )
}

export { EmailConfirmation }
